import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import {
  ErrorBannerContainer,
  ErrorBanner,
  IconTextWrapper,
  ErrorText,
} from './styles/ObliqueImageryErrorBanner.styles';

export const ObliqueImageryErrorBanner = ({ isOpened, setHasError }) => {
  const clearError = e => {
    setHasError(false);
    e.stopPropagation();
  };
  return (
    <ErrorBannerContainer onClick={clearError} isVisible={isOpened}>
      <ErrorBanner>
        <IconTextWrapper horizontal>
          <Box mr="12px">
            <AttentionTriangleIcon width={16} height={16} color="white" />
          </Box>
          <ErrorText size="normal">
            EagleView Imagery failed to load. Please try again or contact
            support team at{' '}
            <a href="mailto:support@rapidsos.com">support@rapidsos.com</a>.
          </ErrorText>
        </IconTextWrapper>
      </ErrorBanner>
    </ErrorBannerContainer>
  );
};
